module.exports = __webpack_public_path__ + "static/media/background.ba7a3ab6.png";